import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getRaceKindFilterForStatsSlice = createSlice({
    name: 'RaceKindFilterForStats',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchRaceKindFilterForStats.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchRaceKindFilterForStats.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchRaceKindFilterForStats.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setRaceKindFilterForStats, setStatus } = getRaceKindFilterForStatsSlice.actions;
export default getRaceKindFilterForStatsSlice.reducer;

export const fetchRaceKindFilterForStats = createAsyncThunk('/RaceKindFilterForStats/fetch', async ({
    StartDate,
    EndDate,
    Nationality,
    RaceCourse,
    GroundType,
    RaceKind,
    HorseKind,
    RaceType,
    TrackLength}) => {
    const res = await axios.get(`${getBaseUrl()}/RaceKindFilterForStats?StartDate=${StartDate === undefined ? "" : StartDate}&EndDate=${EndDate === undefined ? "" : EndDate}&Nationality=${Nationality === undefined ? "" : Nationality}&RaceCourse=${RaceCourse === undefined ? "" : RaceCourse}&GroundType=${GroundType === undefined ? "" : GroundType}&RaceKind=${RaceKind === undefined ? "" : RaceKind}&HorseKind=${HorseKind === undefined ? "" : HorseKind }&RaceType=${RaceType=== undefined ? "" : RaceType}&TrackLength=${TrackLength === undefined ? "" : TrackLength}&size=40`);
    const RaceKindFilterForStatsData = res.data;
    return RaceKindFilterForStatsData.data;
})
